import React, { useEffect, useState } from "react";
import "./HeaderDash.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faUserCircle,
  faCalendarAlt,
  faSignOutAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

// Radix UI
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";

// 👉 NUEVO
import PerfilModal from "../PerfilModal/PerfilModal";

export default function HeaderDash() {
  const navigate = useNavigate();
  const [openPerfil, setOpenPerfil] = useState(false);

  useEffect(() => {
    const color = "#3cbf9b";
    document.documentElement.style.setProperty("--primary-color", color);
    document.documentElement.style.setProperty("--color1", color);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <>
      <div className="HeaderDashContain">
        {/* SEARCH */}
        <div className="searchWrap">
          <div className="searchIconCircle">
            <FontAwesomeIcon icon={faSearch} className="searchIcon" />
          </div>
          <input className="searchInput" type="text" placeholder="Buscar..." />
        </div>

        {/* BOTONES DERECHA */}
        <div className="deFlexHeader">
          <button className="headerBtn">
            <FontAwesomeIcon icon={faCalendarAlt} />
            <span>Pedidos</span>
          </button>

          {/* DROPDOWN */}
          <DropdownMenu.Root>
            <DropdownMenu.Trigger className="headerBtn profileBtn">
              <FontAwesomeIcon icon={faUserCircle} />
              <span>Perfil</span>
            </DropdownMenu.Trigger>

            <DropdownMenu.Content className="profileDropdown" sideOffset={10}>
              <DropdownMenu.Item
                className="dropdownItem"
                onClick={() => setOpenPerfil(true)}
              >
                <FontAwesomeIcon icon={faUser} />
                <span>Mi Perfil</span>
              </DropdownMenu.Item>

              <DropdownMenu.Separator className="dropdownDivider" />

              <DropdownMenu.Item
                className="dropdownItem"
                onClick={handleLogout}
              >
                <FontAwesomeIcon icon={faSignOutAlt} />
                <span>Cerrar sesión</span>
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        </div>
      </div>

      {/* 🔽 MODAL PERFIL */}
      <PerfilModal open={openPerfil} onClose={() => setOpenPerfil(false)} />
    </>
  );
}
